import { ActionBase } from '../../../core/store/action/ActionBase';

export const RESET_PASSWORD = '[Customer] User Reset Password';

export class ResetPasswordAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = RESET_PASSWORD;

  constructor(public payload: { user: {key: string, identifier: string} }) {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/customer/store/actions/ResetPasswordAction.ts